var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleA = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59989 2.39999C4.10985 2.39999 4.52669 2.79763 4.55778 3.29976L4.80013 3.5421C5.0813 3.82328 5.0813 4.27905 4.80013 4.56023C4.72926 4.63109 4.64732 4.68404 4.55989 4.71913V19.9263C4.91211 19.9733 5.1838 20.2749 5.1838 20.64C5.1838 21.0376 4.86144 21.36 4.4638 21.36H4.23458C4.06537 21.5093 3.84328 21.6 3.59989 21.6C3.0697 21.6 2.63989 21.1702 2.63989 20.64V3.35999C2.63989 2.8298 3.0697 2.39999 3.59989 2.39999Z",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7838 19.92C9.18144 19.92 9.5038 20.2423 9.5038 20.64C9.5038 21.0376 9.18144 21.36 8.7838 21.36H7.05599C6.65834 21.36 6.33599 21.0376 6.33599 20.64C6.33599 20.2423 6.65834 19.92 7.05599 19.92H8.7838Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1038 19.92C13.5014 19.92 13.8238 20.2423 13.8238 20.64C13.8238 21.0376 13.5014 21.36 13.1038 21.36H11.376C10.9783 21.36 10.656 21.0376 10.656 20.64C10.656 20.2423 10.9783 19.92 11.376 19.92H13.1038Z",
    fill: "#464646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4238 19.92C17.8214 19.92 18.1438 20.2423 18.1438 20.64C18.1438 21.0376 17.8214 21.36 17.4238 21.36H15.696C15.2983 21.36 14.976 21.0376 14.976 20.64C14.976 20.2423 15.2983 19.92 15.696 19.92H17.4238Z",
    fill: "#464646"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6797 19.4398C19.9608 19.1586 20.4166 19.1586 20.6978 19.4398L21.389 20.1309C21.5949 20.3369 21.6565 20.6466 21.545 20.9156C21.4336 21.1846 21.1711 21.36 20.8799 21.36H20.016C19.6183 21.36 19.296 21.0376 19.296 20.64C19.296 20.4471 19.3719 20.2721 19.4954 20.1429C19.4279 19.9007 19.4892 19.6302 19.6797 19.4398Z",
    fill: "#464646"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2236 15.9837C16.5047 15.7025 16.9607 15.7025 17.2419 15.9837L18.6243 17.366C18.9054 17.6472 18.9054 18.1032 18.6243 18.3844C18.3431 18.6655 17.8871 18.6655 17.6059 18.3844L16.2236 17.002C15.9424 16.7208 15.9424 16.2648 16.2236 15.9837Z",
    fill: "#464646"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7675 12.5276C13.0486 12.2464 13.5046 12.2464 13.7858 12.5276L15.1682 13.9102C15.4493 14.1913 15.4493 14.6471 15.1682 14.9283C14.887 15.2094 14.4312 15.2094 14.15 14.9283L12.7675 13.5459C12.4863 13.2648 12.4863 12.8087 12.7675 12.5276Z",
    fill: "#464646"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31161 9.07171C9.59278 8.79054 10.0486 8.79055 10.3297 9.07171L11.7123 10.4541C11.9934 10.7352 11.9935 11.1913 11.7123 11.4724C11.4312 11.7536 10.9751 11.7536 10.694 11.4724L9.31161 10.0898C9.03045 9.80866 9.03044 9.35288 9.31161 9.07171Z",
    fill: "#464646"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85552 5.61562C6.1367 5.33444 6.5927 5.33444 6.87388 5.61562L8.25622 6.99796C8.5374 7.27914 8.5374 7.73514 8.25622 8.01632C7.97504 8.2975 7.51904 8.2975 7.23786 8.01632L5.85552 6.63398C5.57434 6.3528 5.57434 5.8968 5.85552 5.61562Z",
    fill: "#464646"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriangleA);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/triangle_a.6a80eb505fdcaa86cec21ced1c05d311.svg";